import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "details" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Date Registered: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "edit" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Edit Details", -1)
const _hoisted_8 = { class: "grid p-fluid align-items-center" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "First Name", -1)
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Last Name", -1)
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Organization", -1)
const _hoisted_17 = { class: "form-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserLicense = _resolveComponent("UserLicense")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.user.displayName) + "'s Details", 1),
          _createElementVNode("p", null, [
            _hoisted_3,
            _withDirectives((_openBlock(), _createElementBlock("span", null, [
              _createTextVNode(_toDisplayString(_ctx.user.email), 1)
            ])), [
              [
                _directive_tooltip,
                'Email cannot be modified.',
                void 0,
                { top: true }
              ]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.getDateString(_ctx.user.dateRegistered)), 1)
          ]),
          _createVNode(_component_UserLicense, { user: _ctx.user }, null, 8, ["user"]),
          _hoisted_5,
          _createVNode(_component_Button, {
            label: "Delete User",
            type: "button",
            class: "p-button-danger",
            onClick: _withModifiers(_ctx.deleteUser, ["prevent"])
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("form", {
            class: "form",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_InputText, {
                    id: "title",
                    type: "text",
                    modelValue: _ctx.user.firstName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.firstName) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_InputText, {
                    id: "title",
                    type: "text",
                    modelValue: _ctx.user.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.lastName) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_InputText, {
                id: "title",
                type: "text",
                modelValue: _ctx.user.organization,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.organization) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Button, {
                label: "Submit",
                type: "submit"
              })
            ])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}